<template>
  <!-- 维修指标 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">维修指标</span>
    </div>
    <div class="dataWrap">
      <RingDiagram :data="data"></RingDiagram>

      <RingDiagram :data="dataTwo"></RingDiagram>
    </div>
  </div>
</template>

<script>
import RingDiagram from './RingEchart'
export default {
  name: 'RevenueMonitoring',
  components: {
    RingDiagram
  },
  data () {
    return {
      data: [],
      dataTwo: []
    }
  },
  created () {},
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      this.$http.get('/pipe-network/maintenance_indicators/maintenance-quality').then(res => {
        const listDataTwo = res.data[0].result
        listDataTwo.map(item => {
          item.value = parseFloat(item.value)
        })
        this.dataTwo = listDataTwo
        const listData = res.data[1].result
        listData.map(item => {
          item.value = parseFloat(item.value)
        })
        this.data = listData
      })
      // this.data = [
      //   {
      //     name: 'PE管',
      //     value: 42,
      //   },
      //   {
      //     name: '钢管',
      //     value: 32,
      //   },
      //   {
      //     name: '球墨铸铁管',
      //     value: 22,
      //   },
      //   {
      //     name: '其他管材',
      //     value: 4,
      //   },
      // ]

      // this.dataTwo = [
      //   {
      //     name: 'DN100以下',
      //     value: 32,
      //   },
      //   {
      //     name: 'DN100-300',
      //     value: 42,
      //   },
      //   {
      //     name: 'DN300-600',
      //     value: 26,
      //   },
      // ]
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 240px;
  width: 376px;
  background: url(~@/assets/myImg/box-05.png) no-repeat;
  background-size: cover;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    top: -20px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }
  .dataWrap {
    display: flex;
    flex-direction: row;
  }
}
</style>
